define("Ames.StoreEventsCalendar.StoreEventsCalendar", [
	"Ames.StoreEventsCalendar.StoreEventsCalendar.View",
  ], function (StoreEventsCalendarView) {
	"use strict";
  
	return {
	  mountToApp: function mountToApp(application) {
		StoreEventsCalendarView.prototype.application = application;
  debugger
		application.getComponent("CMS").registerCustomContentType({
		  id: "cct_storeeventscalendar",
		  view: StoreEventsCalendarView,
		});
	  },
	};
  });
